(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["enquiry-form-drawer"] && !Shopify.designMode) return;
  try {
    const btnClose = document.querySelector("#enquiry-form-drawer .drawer__close");
  const stickyChat = document.getElementById("shopify-section-whatsapp-sticky-button");

  if (btnClose) {
    btnClose.addEventListener("click", () => {
        const drawer = document.getElementById("enquiry-form-drawer");
        drawer.classList.remove("active");

        if (stickyChat) {
            stickyChat.style.display = 'block';
        }
    })
  }
  } catch(e) { console.error(e); }
})();

})();
